module.exports = __webpack_public_path__ + "img/Portfolio.ee99435a.png";